import { Taxonomy } from "@common/categories";
import { Category } from "@common/types/category";
import { useStandardCategories } from "./useStandardCategories";

export function useUncategorizedCategory(): Category | undefined {
    const standardCategories = useStandardCategories();

    return standardCategories[Taxonomy.uncategorized];
}
